import { fetchWithAuth } from "../api/client";
import { ErrorResponse } from "../types";

export type TranslationLanguage = "es" | "ca" | "en" | "ar";

export interface TranslateTextParams {
  text: string;
  targetLanguage: TranslationLanguage;
  token: string;
}

export async function translateText({
  text,
  targetLanguage,
  token,
}: TranslateTextParams): Promise<string> {
  const res = await fetchWithAuth("Translation", {
    method: "POST",
    token,
    body: JSON.stringify({ text, targetLanguage }),
  });

  if (!res.ok) {
    let message = `Error al traducir (${res.status})`;

    try {
      const err = (await res.json()) as Partial<ErrorResponse>;
      if (err?.message) {
        message = err.message;
      }
    } catch {
      try {
        const rawText = await res.text();
        if (rawText) {
          message = rawText;
        }
      } catch (finalError) {
        console.error(
          "Fallo inesperado al leer la respuesta de error:",
          finalError
        );
        message += " - No se pudo interpretar la respuesta del servidor.";
      }
    }

    throw new Error(message);
  }

  return await res.text();
}

export interface TranslateToAllParams {
  text: string;
  token: string;
}

export interface TranslationsResult {
  ca: string;
  en: string;
  ar: string;
}

export async function translateTextToAll({
  text,
  token,
}: TranslateToAllParams): Promise<TranslationsResult> {
  // Hacer tres llamadas separadas, una por cada idioma
  const [ca, en, ar] = await Promise.all([
    translateText({ text, targetLanguage: "ca", token }).catch(() => ""),
    translateText({ text, targetLanguage: "en", token }).catch(() => ""),
    translateText({ text, targetLanguage: "ar", token }).catch(() => ""),
  ]);

  return {
    ca,
    en,
    ar,
  };
}
